<template>
  <div
    :class="layoutClasses"
    data-cy="ds-grid__layout"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { DSGridLayoutProps } from "../types/props";
import { DS_GRID_LAYOUT_DISTRIBUTION } from "../types/modes";
import { DISTRIBUTION_TO_CLASS_MAP } from "@/src/design_system/layouts_and_containers/grid/constants/mode";

const props = withDefaults(defineProps<DSGridLayoutProps>(), {
  distribution: DS_GRID_LAYOUT_DISTRIBUTION.Cols1,
  dense: false,
});

const layoutClasses = computed(() => [
  "ds-grid__layout",
  DISTRIBUTION_TO_CLASS_MAP[props.distribution],
  { "ds-grid__layout--dense": props.dense },
]);
</script>
